var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProjectTable',{attrs:{"items":_vm.items},on:{"operation":_vm.onOperation}})
}
var staticRenderFns = []

export { render, staticRenderFns }